
export default {
    name: 'visualiser-resultat',
    components: {},
    props: {
        demande: Object,
        evolution_id: {
            type: Number,
            default: 0
        },
        toggler: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            asset_url: '',
            resultat_analyse: {
                nom: ''
            },
            result_file: '',
            can_view: true,
        }
    },

    watch: {
        toggler() {
            this.getFile()
        }
    },

    computed: {
        modalId() {
            if(this.evolution_id) {
                return 'modalResultat' + this.evolution_id
            }

            return 'modalResultat'
        }
    },

    mounted() {
        
    },

    methods: {
        getFile() {
            this.resultat_analyse = this.demande
            if (this.demande === null) {
                this.result_file = null;
            } else if (this.demande.resultat_fichier === null) {
                this.asset_url = ''
                this.result_file = ''
            } else {
                this.asset_url = this.assets_path + '/files/resultats-analyses/'
                this.result_file = this.demande.resultat_fichier
                
            }
            this.can_view = this.checkIfCanViewInFrame(this.result_file)
        },

        checkIfCanViewInFrame(filename) {
            let can_view = true
            if (filename) {
                if (
                    filename.includes('pdf') || filename.includes('png') || 
                    filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                    filename.includes('jpg') || filename.includes('JPG') 
                ) {
                    can_view = true
                } else {
                    can_view = false
                }
            } else {
                can_view = false
            }
            
            return can_view
        }
    }
}


